import Vue from 'vue'
import BRoot from './views/BRoot.vue'
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheck,
  faCode,
  faEnvelope,
  faFax,
  faHandshake,
  faLanguage,
  faMapMarkerAlt,
  faPhone,
  faPhoneAlt,
  faServer,
  faSquare,
  faSquareFull,
} from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import router from './utils/router';
import store from './utils/store';
import { i18n } from "./plugins/i18n";

library.add(far, faLanguage, faServer, faHandshake, faCode, faPhone, faEnvelope, faFax, faMapMarkerAlt, faCheck, faSquare, faSquareFull, faPhoneAlt);

Vue.config.productionTip = false;
Vue.component('fa', FontAwesomeIcon);
Vue.component('fal', FontAwesomeLayers);

new Vue({
  router,
  store,
  i18n,
  render: h => h(BRoot),
}).$mount('#b');
